/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactSettingFieldItemFromJSON, ContactSettingFieldItemToJSON } from './ContactSettingFieldItem';
export function ContactSettingFieldValueFromJSON(json) {
    return ContactSettingFieldValueFromJSONTyped(json, false);
}
export function ContactSettingFieldValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        contactSettingFieldItem: !exists(json, 'contact_setting_field_item')
            ? undefined
            : ContactSettingFieldItemFromJSON(json['contact_setting_field_item']),
        value: !exists(json, 'value') ? undefined : json['value'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at']
    };
}
export function ContactSettingFieldValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        contact_setting_field_item: ContactSettingFieldItemToJSON(value.contactSettingFieldItem),
        value: value.value,
        created_at: value.createdAt,
        updated_at: value.updatedAt
    };
}
